export default __webpack_public_path__ + "static/media/tayybaimg.f888dad8.png";